'use strict';

/**
 * Enum definition file for locked reasons.
 *
 * @module data/enums/reward-types
 */
module.exports = {
    promotionNotificationExist: 'planning.promotionsViewer.notificationExist',
    promotionAssignedToPromoResource:
        'planning.promotionsMaintenance.lockedMessages.assignedToPromoResource',
    promotionWorkflowState: 'planning.promotionsMaintenance.lockedMessages.workflowState',
    promotionSubCampaignWorkflowState:
        'planning.promotionsMaintenance.lockedMessages.subCampaignWorkflowState',
    promotionPastStartDate: 'planning.promotionsMaintenance.lockedMessages.pastStartDate',
    promotionPastEndDate: 'planning.promotionsMaintenance.lockedMessages.pastEndDate',
    promotionParentNotApproved: 'planning.promotionsViewer.parentNotApproved',
    promotionUnSaved: 'planning.promotionsViewer.unsavedPromotion',
    splitPromotion: 'workflow.taskButton.disabledReason.splitPromotion',
    childPromotionNotInTheManualMode: 'planning.promotionsViewer.notInManualMode',
    ghostPromotion: 'planning.promotionsMaintenance.lockedMessages.ghostPromotion',
    promotionAlreadyInManualMode:
        'planning.promotionsMaintenance.lockedMessages.alreadyInManualMode',
    promoResourcesWorkflowState: 'preparation.promoResources.lockedMessages.workflowState',
    promoResourcesPastStartDate: 'preparation.promoResources.lockedMessages.pastStartDate',
    campaignPastStartDate: 'planning.editCampaign.lockedMessages.pastStartDate',
    subCampaignPastStartDate: 'planning.editSubCampaign.lockedMessages.pastStartDate',
    scenarioPastStartDate: 'planning.editScenario.lockedMessages.pastStartDate',
    scenarioPastEndDate: 'planning.editScenario.lockedMessages.pastEndDate',
    taskButtonRequirementsNotMet: 'taskButton.disabledReason.requirementsNotMet',
};
